import { render, staticRenderFns } from "./StatisticsDays.vue?vue&type=template&id=5e0924c5&"
import script from "./StatisticsDays.vue?vue&type=script&lang=js&"
export * from "./StatisticsDays.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsDays.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports